import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TranslatePipe } from '@ngx-translate/core';
import { EnableEscCloseDirective, UiButtonComponent } from '@ui';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserSettingsModels } from '@share-models';
import { UserSettingsActions } from '../../data-access/state/user-account-settings.actions';
import { Store } from '@ngrx/store';
import { UserAccountSettingsState } from '../../data-access/state/user-account-settings.reducer';

@Component({
  selector: 'app-change-device-page-view-modal',
  imports: [
    MatDialogClose,
    MatRadioButton,
    MatRadioGroup,
    TranslatePipe,
    UiButtonComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './change-device-page-view-modal.component.html',
  styleUrl: './change-device-page-view-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [EnableEscCloseDirective],
})
export class ChangeDevicePageViewModalComponent implements OnInit {
  private fb = inject(FormBuilder);
  public data = inject<{
    userSettings: UserSettingsModels.UserSettingsDocument;
  }>(MAT_DIALOG_DATA);
  private store$ = inject<Store<UserAccountSettingsState>>(Store);
  private dialogRef = inject(MatDialogRef<ChangeDevicePageViewModalComponent>);

  public devicePageNewViewControl = this.fb.nonNullable.control(true, [
    Validators.required.bind(Validators),
  ]);

  public ngOnInit(): void {
    const { newDevicePageView } = this.data.userSettings;
    if (typeof newDevicePageView === 'boolean') {
      this.devicePageNewViewControl.patchValue(newDevicePageView);
    }
  }

  public save(): void {
    const formValue = this.devicePageNewViewControl.value ?? true;
    this.store$.dispatch(
      UserSettingsActions.updateDevicePageView({
        newDevicePageView: formValue,
      }),
    );
    this.close();
  }

  public close(): void {
    this.dialogRef.close();
  }
}
